import {
  ChangeDetectionStrategy,
  Component,
  Directive,
  HostListener,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';

import { accordionAnimation, arrowRotateAnimation } from '../common-ui';

import { PanelService } from './panel.service';

/**
 * Panel
 */
@Component({
  selector: 'app-panel',
  template: `
    <ng-content select="app-panel-header"></ng-content>
    <div *ngIf="(!expandable && expanded) || (expandable && service.expanded$ | async)" [@toggle]>
      <ng-container *ngTemplateOutlet="contentEl"></ng-container>
    </div>
    <ng-template #contentEl>
      <ng-content select="app-panel-content"></ng-content>
    </ng-template>
  `,
  styleUrls: ['./panel.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [accordionAnimation],
  providers: [PanelService],
  host: { class: 'app-panel' },
})
export class PanelComponent implements OnInit {
  @Input() expandable: boolean;

  @Input() expanded = false;

  constructor(public service: PanelService) {}

  ngOnInit(): void {
    this.service.initPanel(this.expanded);
  }
}

/**
 * Panel header
 */
@Component({
  selector: 'app-panel-header',
  template: `
    <mat-icon *ngIf="panel.expandable" [@arrowRotate]="expandedState"> expand_more </mat-icon>
    <ng-content></ng-content>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [arrowRotateAnimation],
  host: { class: 'app-panel-header', '[class.app-expandable]': 'panel.expandable' },
})
export class PanelHeaderComponent {
  constructor(public panel: PanelComponent) {}

  @HostListener('click') toggle(): void {
    if (this.panel.expandable) {
      this.panel.expanded = !this.panel.expanded;
      this.panel.service.toggle(this.panel.expanded);
    }
  }

  get expandedState(): 'expanded' | 'collapsed' {
    return this.panel.expanded ? 'expanded' : 'collapsed';
  }
}

/**
 * Panel Content
 */
@Component({
  selector: 'app-panel-content',
  template: ` <ng-content></ng-content> `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'app-panel-content' },
})
export class PanelContentComponent {}

/**
 * Panel Text Directive
 */
@Directive({
  selector: '[appPanelText]',
  host: { class: 'app-panel-text' },
})
export class PanelTextDirective {}
